import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { redirect } from '@tanstack/router-core';
import { api } from '~/components/Providers/APIClient';
import { ToastKey } from '~/util/types/toasts';
import { FullTokenData, getAppSession } from './session';
import { UserResolved } from '~/util/types/users';
import { z } from 'zod';

export const startLoginServer = createServerFn().handler(async () => {
    const req = getRequest();
    const url = new URL(req.url);

    throw redirect({
        href: `${api.baseUrl}/auth/discord?callback=${encodeURIComponent(
            url.origin + '/login',
        )}`,
    });
});

type completeLoginServerOutput = {
    ok: boolean;
    showToast: ToastKey;
};

export const completeLoginServer = createServerFn({ method: 'POST' })
    .validator(
        z.object({
            token: z.string().min(1),
        }),
    )
    .handler(async (context): Promise<completeLoginServerOutput> => {
        const { token } = context.data;

        const refreshResponse = await api.send<FullTokenData>({
            path: '/auth/refresh',
            token,
        });

        if (refreshResponse.error) {
            console.error('Failed to get refresh token:', refreshResponse);
            return {
                ok: false,
                showToast: 'loginFailedToken',
            };
        }

        const userResponse = await api.send<UserResolved>({
            path: '/users/@me',
            token,
        });

        if (userResponse.error) {
            console.error('Failed to get user data:', userResponse);
            return {
                ok: false,
                showToast: 'loginFailedUser',
            };
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { badges: _, ...user_data } = userResponse.data;

        const session = await getAppSession();
        session.data = {
            ...refreshResponse.data,
            ...user_data,
        };
        await session.save();

        return {
            ok: true,
            showToast: 'loginSuccess',
        };
    });
